import { Outlet } from "react-router-dom";
import AdminRouteLayout from "../../navigation/AdminRouteLayout";

const LeaseNotesRoot = () => {
  return (
    <AdminRouteLayout>
      <Outlet />
    </AdminRouteLayout>
  );
};

export default LeaseNotesRoot;
